export enum ToastContainers {
	LayoutBottomHeader = 'layoutBottomHeaderToastContainer',
	LoginPageTop = 'loginToastContainer'
}
